import React from 'react';
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import AutoRenewalToggle from './AutoRenewalToggle';

const DetailsStep = ({
  customerName,
  setCustomerName,
  email,
  setEmail,
  phoneNumber,
  setPhoneNumber,
  autoRenewal,
  setAutoRenewal
}) => {
  return (
    <div className="space-y-4">
      <div className="mb-4">
        <label className="block mb-1">Customer Name *</label>
        <input
          type="text"
          value={customerName}
          onChange={(e) => setCustomerName(e.target.value)}
          placeholder="Enter your name"
          className="w-full bg-[#022A52] border rounded-md p-2 text-white"
        />
      </div>

      <div className="mb-4">
        <label className="block mb-1">Email *</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="example@mail.com"
          className="w-full bg-[#022A52] border rounded-md p-2 text-white"
        />
      </div>

      <div className="mb-6">
        <label className="block mb-1">Phone *</label>
        <PhoneInput
          country="gh"
          value={phoneNumber}
          onChange={setPhoneNumber}
          enableSearch
          containerClass="w-full"
          inputClass="w-full bg-[#022A52] text-black p-2 rounded-md border border-gray-400"
          buttonClass="bg-[#022A52] text-black"
        />
      </div>

      <AutoRenewalToggle
        autoRenewal={autoRenewal}
        setAutoRenewal={setAutoRenewal}
      />
    </div>
  );
};

export default DetailsStep;